var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    ref: "psvdbg",
    staticClass: "PSViewer",
    staticStyle: {
      height: "calc(100vh - 148px)"
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };